import parameterConfiguration from './view/parameterConfiguration.html'


export default {
    base: {
        state: 'declaration.personalIncomeTax.parameterConfiguration',
        config: {
            url: '/parameterConfiguration',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'declaration.personalIncomeTax.parameterConfiguration.list',
            title: '参数配置',
        },
    },
    list: {
        state: 'declaration.personalIncomeTax.parameterConfiguration.list',
        config: {
            url: '/list',
            template: parameterConfiguration,
            controller: 'parameterConfigurationCtrl',
        },
    },
    edit: {
        state: 'declaration.personalIncomeTax.parameterConfiguration.edit',
        config: {
            url: '/edit/:id',
            template: require('./view/parameterConfigurationEdit.html'),
            controller: 'parameterConfigurationEditCtrl',
            title: '编辑',
        },
    },
    add: {
        state: 'declaration.personalIncomeTax.parameterConfiguration.add',
        config: {
            url: '/add',
            template: require('./view/parameterConfigurationEdit.html'),
            controller: 'parameterConfigurationEditCtrl',
            title: '新增',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/parameterConfiguration/routers.js